<script setup>
const goChatbot = () => {
  if (typeof window === "undefined") return;

  gtag("event", "Index_click", { action: "goChatbot", page: "hero" });
  if (localStorage.utm_ref != null) {
    window.open(
      "https://chatxbuy-springboard.web.app?ref=" + localStorage.utm_ref,
    );
  } else {
    window.open("https://chatxbuy-springboard.web.app");
  }
};
</script>

<template>
  <img
    style="display: block; width: 221px; margin-inline: auto; cursor: pointer"
    @click="goChatbot"
    src="@/assets/images/mobile/advantage/Frame_624684.png"
    alt="代買幫"
  />
</template>
